<template>
	<div class="page-wrap">
		<!-- 背景图片 -->
		<el-image class="pbg" :src="require('@/static/login.svg')" fit="cover"></el-image>
		<!-- 注册卡片 -->
		<div class="register-card animate__animated animate__fadeIn">
			<!-- 返回登录 -->
			<div class="back-login fade-up" style="animation-delay: 0.1s" @click="link('/login')">
				<el-image class="back-icon" :src="require('@/static/add2/3.png')"></el-image>
				<span>{{ $t('registerPage.backLogin') }}</span>
			</div>
			<!-- 标题 -->
			<p class="title fade-up" style="animation-delay: 0.15s">{{ $t('registerPage.title') }}</p>
			<!-- 图标 -->
			<div class="icon-wrap">
				<el-image :src="require('@/static/add2/4.png')"></el-image>
			</div>
			<!-- 注册方式选择行 -->
			<div class="input-area mode-area fade-up" style="animation-delay: 0.25s">
				<span class="mode-label">{{ $t('registerPage.modeLabel') }}</span>
				<div class="mode-options">
					<span class="mode-item" @click="regMode = 'phone'">
						<el-image v-if="regMode === 'phone'" class="radio-icon" :src="require('@/static/add2/2.png')"></el-image>
						<el-image v-else class="radio-icon" :src="require('@/static/add2/1.png')"></el-image>
						<span :class="['mode-text', { active: regMode === 'phone' }]">{{ $t('registerPage.phoneMode') }}</span>
					</span>
					<el-image class="divider-icon" :src="require('@/static/CodeBuddyAssets/31246_2252/2.svg')"></el-image>
					<span class="mode-item" @click="regMode = 'email'">
						<el-image v-if="regMode === 'email'" class="radio-icon" :src="require('@/static/add2/2.png')"></el-image>
						<el-image v-else class="radio-icon" :src="require('@/static/add2/1.png')"></el-image>
						<span :class="['mode-text', { active: regMode === 'email' }]">{{ $t('registerPage.emailMode') }}</span>
					</span>
				</div>
			</div>
			<!-- 手机号 -->
			<div class="input-area phone-area fade-up" v-if="regMode === 'phone'" style="animation-delay: 0.3s">
				<el-input v-model="mobile" :placeholder="$t('registerPage.mobilePlaceholder')"></el-input>
			</div>
			<!-- 邮箱 -->
			<div class="input-area phone-area fade-up" v-else style="animation-delay: 0.3s">
				<el-input v-model="email" :placeholder="$t('registerPage.emailPlaceholder')"></el-input>
			</div>
			<!-- 验证码输入 -->
			<div class="input-area code-area fade-up" style="animation-delay: 0.35s">
				<el-input v-model="code" :placeholder="$t('registerPage.codePlaceholder')">
					<template slot="suffix">
						<div class="code-suffix">
							<el-image class="code-divider" :src="require('@/static/CodeBuddyAssets/31246_2252/1.svg')"></el-image>
							<span class="get-code" :class="{ disabled: counting }" @click="startCountdown">{{ counting ? countdown + 's' : $t('registerPage.getCode') }}</span>
						</div>
					</template>
				</el-input>
			</div>
			<!-- 登录密码 -->
			<div class="input-area pwd-area fade-up" style="animation-delay: 0.4s">
				<el-input v-model="password" type="password" :placeholder="$t('registerPage.passwordPlaceholder')" show-password></el-input>
			</div>
			<!-- 确认密码 -->
			<div class="input-area confirm-area fade-up" style="animation-delay: 0.45s">
				<el-input v-model="confirmPwd" type="password" :placeholder="$t('registerPage.confirmPwdPlaceholder')" show-password></el-input>
			</div>
			<!-- 注册按钮 -->
			<div class="register-btn fade-up" @click="submit" style="animation-delay: 0.5s">{{ $t('registerPage.registerBtn') }}</div>
		</div>
	</div>
</template>

<script>
import {
	authMemberinfo,
	authMemberregister,
	smsmobile,
	smsemail,
} from "/src/api/api.js"
export default {
	data() {
		return {
			// 账号类型
			regMode: 'phone',
			// 表单
			mobile: '',
			email: '',
			code: '',
			password: '',
			confirmPwd: '',
			// 验证码
			countdown: 0,
			counting: false,
			timer: null,
		}
	},
	beforeDestroy() {
		if (this.timer) clearInterval(this.timer);
	},
	methods: {
		// 手机号密码登录/验证码登录
		async submit(){
			var res;
			res = await authMemberregister({
				accountType:this.regMode==='phone'?1:2,
				email:this.email,
				mobile:this.mobile,
				code:this.code,
				password:this.password,
				confirmPassword:this.confirmPwd,
			});
			if(res.code==200){
				this.$store.commit('userMsg/tokenC',res.msg);
				this.getinfo()
			}else{this.Tips(res.msg,'error')}
		},
		// 获取用户信息
		async getinfo(){
			const res = await authMemberinfo({});
			if(res.code==200){
				this.$store.commit('userMsg/userInfoC',res.data);
				this.Tips(this.$t('registerPage.registerSuccess'),'success')
				setTimeout(()=>{
					this.link('/indexHome')
				},1500)
			}else{this.Tips(res.msg,'error')}
		},
		// 验证码
		async startCountdown() {
			if (this.counting) return;
			var res;
			if(this.regMode === 'email'){
				res = await smsemail({email:this.email});
			}else{
				res = await smsmobile({mobile:this.mobile});
			}
			if(res.code==200){
				this.counting = true;
				this.countdown = 120;
				this.timer = setInterval(() => {
					this.countdown--;
					if (this.countdown <= 0) {
						this.counting = false;
						clearInterval(this.timer);
						this.timer = null;
					}
				}, 1000);
			}else{this.Tips(res.msg,'error')}
		},
	},
}
</script>

<style lang="scss" scoped>
@keyframes fadeInUp {
	from {
		opacity: 0;
		transform: translateY(0.15rem);
	}
	to {
		opacity: 1;
		transform: translateY(0);
	}
}
.fade-up {
	opacity: 0;
	animation: fadeInUp 0.5s ease forwards;
}
.page-wrap {
	position: relative;
	width: 100vw;
	height: 100vh;
	overflow: hidden;
}
.pbg {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	display: block !important;
	::v-deep .el-image__inner {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
}
.register-card {
	position: absolute;
	top: 50%;
	right: 2rem;
	transform: translateY(-50%);
	width: 4.74rem;
	height: 6.25rem;
	background: #fff;
	border-radius: 0.1rem;
	border-radius: 0.1rem;
	background: linear-gradient(180deg, rgba(255, 255, 255, 0.72) 0%, rgba(180, 215, 251, 0.6) 100%);
	
	border: 2px solid #fff;
}
.back-login {
	position: absolute;
	top: 0.24rem;
	left: 0.2rem;
	display: flex;
	align-items: center;
	cursor: pointer;
	.back-icon {
		width: 0.16rem;
		height: 0.16rem;
		margin-right: 0.06rem;
	}
	span {
		color: #1D65B5;
		font-size: 0.16rem;
		font-weight: 500;
	}
	&:hover span {
		text-decoration: underline;
	}
}
.title {
	position: absolute;
	top: 0.54rem;
	left: 0;
	right: 0;
	text-align: center;
	font-size: 0.24rem;
	font-weight: 500;
	color: #1D65B5;
}
.icon-wrap {
	position: absolute;
	top: 0.98rem;
	left: 50%;
	transform: translateX(-50%);
	.el-image {
		display: block;
		width: 26px;
		height: 6px;
	}
}
.input-area {
	position: absolute;
	left: 0.4rem;
	width: 3.94rem;
	height: 0.56rem;
	&.mode-area {
		top: 1.33rem;
		background: #F8F8F8;
		border-radius: 0.06rem;
		border: 0.01rem solid #E6E8EA;
		display: flex;
		align-items: center;
		padding: 0 0.18rem;
	}
	&.phone-area {
		top: 2.13rem;
	}
	&.code-area {
		top: 2.93rem;
	}
	&.pwd-area {
		top: 3.73rem;
	}
	&.confirm-area {
		top: 4.53rem;
	}
	::v-deep .el-input__inner {
		width: 100%;
		height: 0.56rem;
		background: #F8F8F8;
		border-radius: 0.06rem;
		border: 0.01rem solid #E6E8EA;
		padding: 0 0.18rem;
		font-size: 0.16rem;
		color: #333;
		&::placeholder {
			color: #A5A8AF;
		}
	}
	::v-deep .el-input {
		height: 0.56rem;
	}
}
.mode-label {
	color: #333333;
	font-size: 0.16rem;
	white-space: nowrap;
	margin-right: auto;
}
.mode-options {
	display: flex;
	align-items: center;
	.mode-item {
		display: flex;
		align-items: center;
		cursor: pointer;
	}
	.radio-icon {
		width: 0.20rem;
		height: 0.20rem;
		margin-right: 0.12rem;
	}
	.mode-text {
		color: #333333;
		font-size: 0.16rem;
		&.active {
			color: #1D65B5;
		}
	}
	.divider-icon {
		width: 0.01rem;
		height: 0.2rem;
		margin: 0 0.14rem;
	}
}
.code-area {
	::v-deep .el-input__inner {
		padding-right: 1.05rem;
	}
	::v-deep .el-input__suffix {
		right: 0.18rem;
		top: 50%;
		transform: translateY(-50%);
		display: flex;
		align-items: center;
	}
}
.code-suffix {
	display: flex;
	align-items: center;
	.code-divider {
		width: 0.01rem;
		height: 0.2rem;
		margin-right: 0.1rem;
	}
	.get-code {
		color: #1D65B5;
		font-size: 0.16rem;
		cursor: pointer;
		white-space: nowrap;
		&.disabled {
			color: #A5A8AF;
			cursor: not-allowed;
		}
	}
}
.register-btn {
	position: absolute;
	top: 5.40rem;
	left: 0.4rem;
	width: 3.94rem;
	height: 0.48rem;
	background: #1D65B5;
	border-radius: 0.1rem;
	color: #fff;
	font-size: 0.18rem;
	font-weight: 500;
	text-align: center;
	line-height: 0.48rem;
	cursor: pointer;
	transition: all 0.3s ease;
	background: linear-gradient(90deg, #1F6EBD 0%, #0096FF 100%);

	// &:hover {
	// 	background: #33ABFF;
	// 	box-shadow: 0 0.04rem 0.12rem rgba(0, 150, 255, 0.4);
	// 	transform: translateY(-0.02rem);
	// }
	// &:active {
	// 	background: #0081D9;
	// 	transform: translateY(0);
	// 	box-shadow: 0 0.02rem 0.06rem rgba(0, 150, 255, 0.3);
	// }
}
</style>
